import {create} from "zustand";

type authStore = {
    
    email: string;
    setEmail: (email: string) => void;
    
    password: string;
    setPassword: (password: string) => void;

    verifyPassword: string;
    setVerifyPassword: (verifyPassword: string) => void;

    showPassword: boolean;
    setShowPassword: (showPassword: boolean) => void;

    code: string;
    setCode: (code: string) => void;

    remember: boolean;
    setRemember: (remember: boolean) => void;

    reset: () => void;
}

export const useAuthStore = create<authStore>((set) => ({
    email : "",
    setEmail: (email: string) => set({ email }),

    password : "",
    setPassword: (password: string) => set({ password }),

    verifyPassword : "",
    setVerifyPassword: (verifyPassword: string) => set({ verifyPassword }),

    showPassword : false,
    setShowPassword: (showPassword: boolean) => set({ showPassword }),

    code : "",
    setCode: (code: string) => set({ code }),

    remember : false,
    setRemember: (remember: boolean) => set({ remember }),

    reset: () => set({ email: "", password: "", verifyPassword: "", showPassword: false, code: "", remember: false })
}))